<!--
 * @Descripttion: 
 * @Author: qixiao
 * @Date:2022-07-04 09:46:59
 * @LastEditors: yangsibo
 * @LastEditTime: 2024-09-06 08:54:13
-->
<style>
@font-face {
  font-family: "iconfont"; /* Project id 2225483 */
  src: url("//at.alicdn.com/t/font_2225483_4ty3jpxlwb.woff2?t=1631585093621")
      format("woff2"),
    url("//at.alicdn.com/t/font_2225483_4ty3jpxlwb.woff?t=1631585093621")
      format("woff"),
    url("//at.alicdn.com/t/font_2225483_4ty3jpxlwb.ttf?t=1631585093621")
      format("truetype");
}
</style>
<template>
  <div class="apps">
    <el-main>
      <div class="top-wrap">
        <Bread></Bread>
      </div>
      <div class="main">
        <div class="box-top">
          <div class="spanLeft">
            <span class="greenSpan"></span>
            <span class="leftfont">设置对应时间点摄像头的拍摄角度</span>
          </div>
          <div class="spanRight">
            <span class="greenSpan"></span>
            <span class="leftfont">拍摄点查看</span>
          </div>
          <div class="spanLeft2">
            <span class="greenSize">第一步：</span>
            <el-time-select
              v-model="timeVal"
              size="small"
              :picker-options="{
                start: '08:00',
                step: '01:00',
                end: '17:00',
              }"
              placeholder="时间点选择"
            >
            </el-time-select>
            <span class="greenSize ml50">第二步：调整拍摄角度</span>
          </div>

          <div style="position: absolute; width: 70%">
            <el-alert
              title="操作说明：通过右侧按钮调整摄像头上、下、左、右的位置，找到拍摄时间点最佳光线角"
              type="warning"
              description="度（顺着光照方向）采集作物长势数据，保存该设置信息，摄像头会在该时间自动拍摄。"
              show-icon
            >
            </el-alert>
          </div>
          <div
            id="playWindY"
            style="
              display: inline-block;
              width: 70%;
              height: 60vh;
              background: #ccc;
              position: relative;
            "
          ></div>
          <div style="position: absolute; width: 70%">
            <div class="kongzhi">
              <div class="sx1" @click="ptzControl(1)"></div>
              <div class="sx2" @click="ptzControl(2)"></div>
              <div class="sx3" @click="ptzControl(0)"></div>
              <div class="sx4" @click="ptzControl(3)"></div>
              <div class="sx5"></div>
            </div>
            <div class="fangda" @click="ptzControl(8)"></div>
            <span class="suoxiao" @click="ptzControl(9)"></span>
          </div>
          <div style="position: absolute; width: 70.8%">
            <div class="photo">
              <span
                :style="
                  pointerEventer
                    ? 'pointer-events: auto'
                    : 'pointer-events: none'
                "
                @click="handleCapture"
                ><i class="el-icon-camera-solid"></i
              ></span>
              <span class="fffFs"
                >设备序列号:<span> {{ code }} </span></span
              >
              <span class="ctrlS" @click="trueBtn"> </span>
            </div>
          </div>

          <div class="box-t-right">
            <!-- <div class="videoBtnBox">
              <button class="iconfont buttonIcon" @click="ptzControl(0)">
                &#xe602;<span>上翻</span>
              </button>
              <button class="iconfont buttonIcon" @click="ptzControl(2)">
                &#xe605;<span>左翻</span>
              </button>
              <button class="iconfont buttonIcon" @click="ptzControl(8)">
                &#xe607;<span>放大</span>
              </button>
              <button class="iconfont buttonIcon" @click="ptzControl(1)">
                &#xe603;<span>下翻</span>
              </button>

              <button class="iconfont buttonIcon" @click="ptzControl(3)">
                &#xe604;<span>右翻</span>
              </button>

              <button class="iconfont buttonIcon" @click="ptzControl(9)">
                &#xe60a;<span>缩小</span>
              </button>
            </div> -->

            <!-- <p class="box-center">
              设置此位置为
              <el-time-select
                clear-icon="el-icon-circle-close"
                v-model="timeVal"
                size="small"
                :picker-options="{
                  start: '09:00',
                  step: '01:00',
                  end: '16:00',
                }"
                placeholder="选择时间"
              >
              </el-time-select>
              的拍摄点位 <u @click="trueBtn"> <i>确定</i> </u>
            </p> -->
            <el-table
              :data="tableData"
              style="width: 94%"
              border
              :header-cell-style="tableHeaderStyle"
              :row-style="rowClass"
            >
              <el-table-column
                type="index"
                align="center"
                label="序号"
                width="50"
              >
              </el-table-column>
              <el-table-column prop="indexName" align="center" label="位置点">
                <template slot-scope="scope">
                  <div>
                    <u id="yzd" @click="blueTabClick(scope.row)">{{
                      scope.row.indexName
                    }}</u>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="timeH" align="center" label="时间点">
                <template slot-scope="scope">
                  <div>
                    <span v-show="scope.row.timeH < 10">0</span
                    >{{ scope.row.timeH }}:00
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="50">
                <template slot-scope="scope">
                  <span>
                    <span class="del" @click="removes(scope.row)">删除</span>
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <footer>
        <span>技术服务：金色大田科技有限公司</span>
      </footer>
    </el-main>
  </div>
</template>

<script>
var EZUIKit;
var ms_ie = false;
var ua = window.navigator.userAgent.toLowerCase();
var old_ie = ua.indexOf("MSIE");
var new_ie = ua.indexOf("trident/");
var is360 = false;
var append = document.getElementById("append");
if (old_ie > -1 || new_ie > -1) {
  EZUIKit = false;
  ms_ie = true;
}
if (window.navigator.appName.indexOf("Microsoft") != -1) {
  me_ie = true;
}
if (window.navigator.mimeTypes[40] || !window.navigator.mimeTypes.length) {
  is360 = true;
}

if (ms_ie) {
  EZUIKit = false;
  var DEFAULT_VERSION = 8.0;
  var ua = navigator.userAgent.toLowerCase();
  var isIE = ua.indexOf("msie") > -1;
  var safariVersion;
  if (isIE) {
    safariVersion = ua.match(/msie ([d.]+)/)[1];
  }
  if (safariVersion <= DEFAULT_VERSION) {
    console.log(
      "系统检测到您正在使用ie8以下内核的浏览器，不能实现完美体验，请更换或升级浏览器访问！"
    );
  }
}
if (EZUIKit != false) {
  EZUIKit = require("@/utils/ezuikit.js");
}
import axios from "axios";
export default {
  name: "AgrMonitoringPreset",
  data() {
    return {
      tableData: [],
      value1: [],
      timeVal: "",
      realData: {
        deviceCode: "-",
        deviceName: "-",
        deviceTypeName: "-",
      },
      videoInfo: {
        deviceCode: "",
      },
      redFlag: "fal",
      offWid: "",
      offHei: "",
      video_Src: "",
      video_Token: "",
      flag: false,
      EZUIKit: EZUIKit,
      player: "",
      loading: null,
      code: this.$route.query.code,
      isTurn: false,
      btnHei: "",
      pointerEventer: false,
    };
  },
  mounted() {
    var foot = document.querySelector(".el-footer");
    if (foot) {
      foot.setAttribute("id", "el-footers");
    }
    this.fn();
  },
  destroyed() {
    if (this.player) {
      this.player.stop();
      this.player = null;
    }
  },
  beforeDestroy() {
    if (this.player) {
      this.player.stop();
      this.player = null;
    }
  },
  beforeCreate() {},
  created() {
    this.get_PresetAdd();
  },
  methods: {
    tableHeaderStyle({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return `
       background-color: #f8f8f8;
       `;
      }
    },
    rowClass(row) {
      return `border: 1px solid #e4e4e4;`;
      // if ((row.rowIndex + 1) % 2 == 0) {
      //   return {
      //     border: "1px solid #e4e4e4",
      //   };
      // } else {

      // }
    },
    fn() {
      if (this.player) {
        this.player = null;
        this.player.stop();
      } else {
        let farmAllData = JSON.parse(sessionStorage.getItem("farmAllData"));
        this.realData = {
          deviceCode: this.code,
          deviceName: "farmAllData.deviceName",
          deviceTypeName: "farmAllData.deviceTypeName",
        };
        this.videoInfo.deviceCode = this.realData.deviceCode;
        var dom = document.querySelector(".box-top");
        // var heig = document.querySelector(".videoBtnBox");
        // let ass = heig.offsetHeight;
        this.offWid = dom.offsetWidth * 0.7;
        this.offHei = dom.offsetHeight;
        this.btnHei = this.offHei + 38;
        // console.log(this.btnHei);
        let obj = { deviceSerial: this.realData.deviceCode, channelNo: "1" }; // 1-高清（主码流）、2-流畅（子码流）
        this.$http.agrModel
          .getVideoUrl(obj)
          .then((res) => {
            // console.log(res);
            if (res.data.code === "200") {
              this.pointerEventer = true;

              // console.log("视频接口===", res);
              var that = this;
              this.video_Src = res.data.data.url;
              this.video_Token = res.data.hkystoken;
              this.flag = true;
              // console.log(this.video_Src);
              // console.log(this.video_Token);
              if (this.EZUIKit) {
                this.player = new EZUIKit.EZUIKitPlayer({
                  id: "playWindY",
                  url: that.video_Src,
                  autoplay: true,
                  accessToken: that.video_Token,
                  width: this.offWid,
                  height: this.offHei,
                  themeData: this.security,
                });
                // console.log(this.offWid);
              } else {
                this.$message({
                  message:
                    "该浏览器对于视频监控不能实现完美体验，请更换或升级浏览器访问！",
                  type: "error",
                  customClass: "customClass",
                });
              }
            } else if (res.code == "20014") {
              this.pointerEventer = false;
              this.flag = false;
              this.$message({
                message: "设备不存在",
                type: "error",
                customClass: "customClass",
              });
            } else if (res.code == "20018") {
              this.pointerEventer = false;

              this.flag = false;
              this.$message({
                message: "设备异常，请联系管理员",
                type: "error",
                customClass: "customClass",
              });
            } else {
              this.pointerEventer = false;

              this.flag = false;
              this.$message({
                message: "设备不在线",
                type: "error",
                customClass: "customClass",
              });
            }
          })
          .catch((err) => {
            console.log(err);
            console.log("视频加载失败");
          });
      }
      // });
    },
    get_PresetAdd() {
      let obj = { deviceSerial: this.code };
      this.$http.agrModel.getPresetGet(obj).then((res) => {
        if (res.status == 1) {
          this.tableData = res.data;
        } else {
          this.$message({
            message: res.errMsg,
            type: "error",
          });
        }
      });
    },

    // 添加拍摄点
    trueBtn() {
      // console.log(this.timeVal);
      if (this.timeVal == null || this.timeVal == "") {
        this.$message({
          message: "请优先选择时间点",
          type: "warning",
        });
      } else {
        this.lodFn();

        let times = this.timeVal.substring(0, 2);
        // console.log(times);
        var objDate = {
          deviceSerial: this.code,
          timeH: times,
          channelNo: "1",
        };
        this.$http.agrModel.getPresetAdd(objDate).then((res) => {
          // console.log(res);
          if (res.status == "1") {
            this.get_PresetAdd();
            this.loading.close();
            if (
              res.data.msg.includes(
                "已存在拍攝点。请删除或者重新选择其他时间点"
              )
            ) {
              this.$message({
                message: res.data.msg,
                type: "warning",
              });
            } else if (res.data.msg.includes("设备不在线")) {
              this.$message({
                message: res.data.msg,
                type: "warning",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
            }
          } else {
            this.loading.close();
            this.$message({
              message: res.errMsg,
              type: "error",
            });
          }
        });
      }
    },
    // 删除拍摄点
    removes(item) {
      // console.log(item);
      var node = document.querySelector("body");
      node.setAttribute("id", "pad0");
      this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.lodFn();
          let obj = {
            deviceSerial: this.code,
            timeH: item.timeH,
            channelNo: "1",
            oldIndex: item.indexs,
          };
          this.$http.agrModel.getPresetDel(obj).then((res) => {
            // console.log(res);
            if (res.status === "1") {
              this.get_PresetAdd();
              this.loading.close();
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            } else {
              this.loading.close();
              this.$message({
                type: "error",
                message: res.errMsg,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    lodFn() {
      this.loading = this.$loading({
        lock: true,
        text: "正在加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    ptzControl(num) {
      this.toControl(this.code, num, 1);
    },
    //控制云台
    toControl(codes, direction, speed) {
      var sta = false;
      if (-1 == direction) {
        this.isTurn = false;
        direction = 2;
        sta = true; //镜头一直转
      }
      if (direction == 111) {
        direction = 2;
        this.isTurn = true;
        //  setTimeout(()=>{
        this.closeControl(codes);
        //  },5000)
      }
      let submitData = {
        deviceSerial: codes,
        channelNo: 1,
        direction: direction,
        speed: speed,
      };
      this.$http.agrModel
        .getVideoStatus(submitData)
        .then((responese) => {
          // console.log(responese);
          if (responese.status === "1") {
            if (!sta) {
              this.closeControl(codes);
            }
          } else {
            this.$message({
              message: responese.errMsg,
              type: "error",
              customClass: "customClass",
            });
          }
        })
        .catch((error) => {
          console.log(error);
          this.$message({
            message: "连接服务器失败",
            type: "error",
            customClass: "customClass",
          });
        });
    },
    //停止云台控制
    closeControl(videoInfo) {
      let submitData = {
        deviceSerial: videoInfo,
        channelNo: 1,
      };
      this.$http.agrModel
        .getVideoStop(submitData)
        .then((responese) => {
          // console.log("responese", responese);
          if (responese.status === "1") {
            console.log("关闭成功！");
          } else {
            this.$message({
              message: responese.errMsg,
              type: "error",
              customClass: "customClass",
            });
          }
        })
        .catch((error) => {
          console.log(error);
          this.$message({
            message: "连接服务器失败",
            type: "error",
            customClass: "customClass",
          });
        });
    },
    // 拍照
    handleCapture() {
      const loading = this.$loading({
        lock: true,
        text: "正在生成照片，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      console.log("点击了拍照");
      let submitData = {
        deviceSerial: this.code,
      };
      this.$http.agrModel
        .getPhotograph(submitData)
        .then((responese) => {
          // console.log(responese);
          if (responese.status === "1") {
            loading.close();
            this.$message({
              message: "拍照成功",
              type: "success",
              customClass: "customClass",
            });
          } else {
            this.$message({
              message: responese.errMsg,
              type: "error",
              customClass: "customClass",
            });
          }
        })
        .catch((error) => {
          console.log(error);
          this.$message({
            message: "连接服务器失败",
            type: "error",
            customClass: "customClass",
          });
        });
    },
    //回到拍摄点位置
    blueTabClick(item) {
      let obj = {
        deviceSerial: this.code,
        channelNo: item.channelNo,
        indexs: item.indexs,
      };
      this.$http.agrModel.getPresetMove(obj).then((res) => {
        // console.log(res);
        if (res.status === "1") {
          this.$message({
            message: res.data.msg,
            type: "success",
            customClass: "customClass",
          });
        } else {
          this.$message({
            message: res.errMsg,
            type: "error",
            customClass: "customClass",
          });
        }
      });
    },
  },
  components: {},
};
</script>
<style>
#pad0 {
  padding-right: 0px !important;
}
#el-footers {
  display: none !important;
  background-color: #fff !important;
}
</style>
<style lang="scss" scoped>
.box-t-right {
  width: 30%;
  display: inline-block;
  vertical-align: top;
  position: absolute;
  background-color: #fff;
  top: 30px;
  height: 100vh;
}
.el-cascader {
  width: 15vw;
  margin-left: 10px;
  margin-right: 10px;
}
::v-deep .el-cascader-menu {
  width: 100px !important;
}
.el-table {
  margin-left: 10px;
  margin-top: 10px;
}
.del {
  cursor: pointer;
  color: #fa5d5d;
}
::v-deep .el-popup-parent--hidden {
  padding-right: 0px !important;
}
body {
  padding-right: 0px !important;
  overflow: hidden;
}
.redFs {
  font-size: 14px;
  color: red;
  margin-left: 10px;
}
.red0 {
  height: 0px;
}
.videoBtnBox {
  width: 98%;
  box-sizing: border-box;
  border: 1px dashed #005293ff;
  margin-left: 10px;
  padding-top: 10px;
  padding-right: 10px;
  padding-left: 10px;
}
.videoBtnBox .buttonIcon:nth-child(even) {
  margin-right: 0;
}
.buttonIcon {
  color: #fff;
  border: none;
  background: #0093ff;
  margin-bottom: 1.5vh;
  width: 30%;
  height: 5vh;
  margin-left: 10px;
  font-size: 0.83vw;
  border-radius: 0.2vw;
  cursor: pointer;
}
.box-center {
  height: 30px;
  color: #888;
  margin-left: 10px;
  margin-top: 20px;
  margin-bottom: 20px;
  text-align: center;
  font-size: 18px;
  font-weight: 550;
}
::v-deep .el-date-editor.el-input {
  width: 120px;
}
::v-deep .el-input__prefix {
  // display: none;

  left: 0px;
}
::v-deep .el-input--prefix .el-input__inner {
  padding-left: 24px;
}
::v-deep .el-input--suffix .el-input__inner {
  padding-right: 20px;
}
u {
  color: blue;
  font-size: 16px;
  cursor: pointer;
  font-weight: 550;
}
.buttonIcon span {
  margin-left: 0.3vw;
}
.photo {
  position: absolute;
  bottom: -1px;
  height: 60px;
  background-color: rgba(0, 0, 0, 0.6);
  width: 100%;
  overflow: hidden;
  i {
    font-size: 30px;
    // float: right;
    margin-left: 14px;
    margin-right: 8px;
    // line-height: 40px;
    vertical-align: middle;
    cursor: pointer;
    color: #fff;
  }
  span:nth-child(2) {
    z-index: -2;
  }
}
.box-top {
  position: relative;
  overflow: hidden;
  .spanLeft {
    display: inline-block;
    margin-bottom: 10px;
    .greenSpan {
      display: inline-block;
      width: 6px;
      height: 24px;
      background-color: #018388;
      border-radius: 15px;
      vertical-align: bottom;
    }
    .leftfont {
      font-size: 20px;
      font-weight: bold;
      color: #323333;
      margin-left: 8px;
    }
  }
  .spanRight {
    display: inline-block;
    width: 29%;
    float: right;
    margin-bottom: 10px;
    .greenSpan {
      display: inline-block;
      width: 6px;
      height: 24px;
      background-color: #018388;
      border-radius: 15px;
      vertical-align: bottom;
    }
    .leftfont {
      font-size: 20px;
      font-weight: bold;
      color: #323333;
      margin-left: 8px;
    }
  }
  .spanLeft2 {
    margin-bottom: 10px;
    .greenSize {
      color: #018388;
      font-weight: 500;
      font-size: 18px;
    }
    .ml50 {
      margin-left: 50px;
    }
  }
}
.fffFs {
  color: #fff;
  line-height: 60px;
  font-size: 18px;
  margin-left: 10px;
}
.ctrlS {
  float: right;
  margin-right: 20px;
  display: inline-block;
  width: 150px;
  height: 46px;
  margin-top: 7px;
  cursor: pointer;
  // margin-right: 10px;
  background: url("../../../assets/agricultural/baocun2.png");
  background-size: 100% 100%;
}
.fangda {
  position: absolute;
  bottom: 135px;
  right: 32px;
  width: 110px;
  height: 43px;
  background: url("../../../assets/agricultural/fangda.png");
  display: inline-block;
  cursor: pointer;
}
.suoxiao {
  position: absolute;
  bottom: 80px;
  right: 32px;
  width: 110px;
  height: 43px;
  background: url("../../../assets/agricultural/suoxiao.png");
  display: inline-block;
  cursor: pointer;
}
.el-alert {
  width: 665px;
  margin-left: 10px;
  margin-top: 10px;
  border-radius: 38px;
  position: absolute;
  z-index: 999;
  left: 0;
  right: 0;
  top: calc(1.7vw);
  margin: auto;
}
.blueTab {
  color: rgb(64, 64, 255);
  font-weight: 550;
  cursor: pointer;
}
.main {
  padding-bottom: 10px !important;
}
.el-main {
  height: calc(100vh - 4.7vw);
}
::v-deep .el-alert__description {
  font-size: 13px;
  font-weight: bold;
}
::v-deep .el-alert__closebtn {
  color: #f00 !important;
}
::v-deep .el-alert__closebtn {
  font-size: 25px;
  top: 18px;
}
.kongzhi {
  z-index: 999;
  position: absolute;
  bottom: 194px;
  right: 5px;
  width: 161px;
  height: 161px;
  border-radius: 100px;
  // background-color: yellow;
  background: url("../../../assets/agricultural/kongzhi.png");
}
.sx1 {
  position: absolute;
  width: 161px;
  height: 161px;
  transform: rotate(-45deg);
  clip: rect(0px, 100px, 200px, 0px);
  border-radius: 100px;
  cursor: pointer;

  // background-color: #f00;
}
.sx2 {
  position: absolute;
  width: 161px;
  height: 161px;
  transform: rotate(45deg);
  clip: rect(0px, 80.5px, 200px, 0px);
  border-radius: 100px;
  cursor: pointer;

  // background-color: yellowgreen;
}
.sx3 {
  position: absolute;
  width: 161px;
  height: 161px;
  transform: rotate(135deg);
  clip: rect(0px, 80.5px, 200px, 0px);
  border-radius: 100px;
  cursor: pointer;

  // background-color: #fff;
}
.sx4 {
  position: absolute;
  width: 161px;
  height: 161px;
  transform: rotate(225deg);
  clip: rect(79.5px, 79.5px, 200px, 0px);
  border-radius: 100px;
  cursor: pointer;

  // background-color: blue;
}
.sx5 {
  position: absolute;
  top: 40.25px;
  left: 40.25px;
  width: 80.5px;
  height: 80.5px;
  border-radius: 50%;
  // cursor: pointer;
  // background: #ccc;
}
.el-alert--error.is-light {
  color: #f00;
}
::v-deep .el-alert__description {
  color: #f00 !important;
}
footer {
  text-align: center;
  height: 40px;
  line-height: 40px;
  color: #8087a2;
  font-size: 18px;
}
#yzd {
  color: #018388;
  font-weight: normal;
}
.el-alert--warning.is-light {
  background-color: #fef0f0;
  color: #f00;
}
::v-deep .el-table.el-table--border .el-table__cell {
  border-right: none;
}
</style>
